import { Route } from "react-router-dom";

const PublicRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  return (
    <Route
      render={({ location, ...props }) => {
        return <Component {...props} />;
      }}
      {...rest}
    />
  );
};

export default PublicRoute;
